import {
    CreationMetadata,
    ListRequestBody,
    MultiselectItem,
    PossibleActions,
    SelectItem,
    State
} from "./admin.interface";
import {BaseDto, InObj, RequestConfig} from "./common.interface";
import {isNonEmptyArray, isNonNull, isNonNullNumber, isNonNullObject} from "../classes/Utils";
import {Upload} from "./media.interface";


export enum ItemTypeAction {
    NEW_ITEM = "newItemType",
    EDIT_ITEM = "editItemType",
    TOGGLE_ITEM = "toggleItemType",
}

export class ItemTypeRequestBody extends ListRequestBody {
    override toRequest(): ListRequestBody {
        const req = JSON.parse(JSON.stringify(this))
        return req;
    }

    override reset() {
        const filter = this.filters.PRODUCT_TYPE
        Object.keys(filter).forEach(field => filter[field] = null)
        filter.state = State.ALL
    }
}

export class ItemTypeData extends BaseDto<ItemTypeInfo, ItemTypeData> {
    name: string;
    state: number;
    company?: MultiselectItem | number;

    public get enabled(): boolean {
        return this.state == 1
    }

    public set enabled(enable: boolean) {
        this.state = enable ? 1 : 0
    }

}

export class ItemTypeInfo extends ItemTypeData {
    id?: number;
    companyName?: string;
    possibleActions?: PossibleActions;
}

export enum ItemCategoryAction {
    NEW_ITEM = "newItemCategory",
    EDIT_ITEM = "editItemCategory",
    TOGGLE_ITEM = "toggleItemCategory",
}

export class ItemCategoryRequestBody extends ListRequestBody {
    override toRequest(): ListRequestBody {
        const req = JSON.parse(JSON.stringify(this))
        const pt = req.filters.PRODUCT_CATEGORY;
        pt.type = isNonNullObject(pt.type) ? pt.type.id : null
        pt.company = isNonEmptyArray(pt.company) ? pt.company : null
        return req;
    }

    override reset() {
        const filter = this.filters.PRODUCT_CATEGORY
        Object.keys(filter).forEach(field => filter[field] = null)
        filter.state = State.ALL
    }
}

export class ItemCategoryData extends BaseDto<ItemCategoryInfo, ItemCategoryData> {
    name: string;
    state: number;
    company?: MultiselectItem | number;
    type: SelectItem | MultiselectItem | number | InObj;

    public get enabled(): boolean {
        return this.state == 1
    }

    public set enabled(enable: boolean) {
        this.state = enable ? 1 : 0
    }

}

export class ItemCategoryInfo extends ItemCategoryData {
    id?: number;
    companyName: string | null;
    possibleActions?: PossibleActions;

    get companyId(): number {
        if (isNonNullObject(this.company) && isNonNull((this.company as MultiselectItem).id))
            return (this.company as MultiselectItem).id
        else if (isNonNullNumber(this.company))
            return this.company as number
        return null;
    }

}

export class ItemSubCategoryRequestBody extends ListRequestBody {
    override toRequest(): ListRequestBody {
        const req = JSON.parse(JSON.stringify(this))
        const pt = req.filters.PRODUCT_SUB_CATEGORY;

        // pt.category = isNonEmptyArray(pt.category) ?
        //         pt.category?.map(r => r.id) : null
        // pt.company = isNonEmptyArray(pt.company) ? pt.company : null

        pt.company = isNonNullObject(pt.company) ? pt.company : []
        pt.type = isNonNullObject(pt.type) ? [pt.type.id] : []
        pt.category = isNonNullObject(pt.category) ? [pt.category.id] : []

        return req;
    }

    override reset() {
        const filter = this.filters.PRODUCT_SUB_CATEGORY
        Object.keys(filter).forEach(field => filter[field] = null)
        filter.state = State.ALL
    }
}

export class ItemSubCategoryData extends BaseDto<ItemSubCategoryInfo, ItemSubCategoryData> {
    name: string;
    state: number;
    company?: MultiselectItem | number;
    category: SelectItem | number;

    public get enabled(): boolean {
        return this.state == 1
    }

    public set enabled(enable: boolean) {
        this.state = enable ? 1 : 0
    }

    override toRequest(obj: ItemSubCategoryInfo, config?: RequestConfig): ItemSubCategoryData {
        const res = super.toRequest(obj, config);
        delete res["type"]
        return res
    }

}

export class ItemSubCategoryInfo extends ItemSubCategoryData {
    id?: number;
    companyName?: string;
    type: SelectItem;
    possibleActions?: PossibleActions;

    get companyId(): number {
        if (isNonNullObject(this.company) && isNonNull((this.company as MultiselectItem).id))
            return (this.company as MultiselectItem).id
        else if (isNonNullNumber(this.company))
            return this.company as number
        return null;
    }

}


export enum ItemAction {
    NEW_ITEM = "newItem",
    EDIT_ITEM = "editItem",
    IMPORT_ITEM = "importItem"
}

export class CatalogUpload {
    upload: Upload;
    description?: string;
}

export class ItemRequestBody extends ListRequestBody {

    override toRequest(): ListRequestBody {
        const req = super.toRequest()
        const pt = req.filters.PRODUCT;

        pt.company = isNonNullObject(pt.company) ? pt.company : []
        pt.type = isNonNullObject(pt.type) ? [pt.type.id] : []
        pt.category = isNonNullObject(pt.category) ? [pt.category.id] : []
        pt.subCategory = isNonNullObject(pt.subCategory) ? [pt.subCategory.id] : []

        return req;
    }

    override reset() {
        const filter = this.filters.PRODUCT
        Object.keys(filter).forEach(field => filter[field] = null)
        filter.state = State.ALL
    }
}

export class ItemData extends BaseDto<ItemCrudInfo, ItemData>{
    id?: number;
    code?: string;
    companyName?: string;
    configuredProduct?: boolean;
    configuredFromDocument?: boolean;
    catalog?: number;
    size?: number;
    description?: string;
    longDescription?: string;
    barcode?: string;
    qrcode?: string;
    ecommerceItem?: boolean;
    warehouseMovement?: boolean;
    fromDocument?: boolean;
    ecommerce?: boolean;
    state?: number;
    company?: number;
    creationMetadata?: CreationMetadata;
    updateDate?: number;
    userLastUpdate?: number;
    possibleActions?: PossibleActions;
    type?: SelectItem
    bomType?: string
    category?: SelectItem
    subCategory?: SelectItem
    um: any;
    supplier: any;
    price: number;
    idDiscount: number;
    hasReplaceableItem?: boolean;
    idProductReplace?: number;


    override toRequest(obj: ItemCrudInfo, config?: RequestConfig): ItemData {
        const req = super.toRequest(obj, config);
        delete req.type
        delete req.category
        return req;
    }
}

export class ItemCrudInfo extends ItemData {

}

export interface ItemInfo extends ItemData {
    id?: number;
    code?: string;
    companyName?: string;
    configuredProduct?: boolean;
    configuredFromDocument?: boolean;
    catalog?: number;
    size?: number;
    primaryUmCode?: string;
    description?: string;
    longDescription?: string;
    barcode?: string;
    qrcode?: string;
    ecommerceItem?: boolean;
    warehouseMovement?: boolean;
    fromDocument?: boolean;
    ecommerce?: boolean;
    state?: number;
    company?: number;
    creationMetadata?: CreationMetadata;
    updateDate?: number;
    userLastUpdate?: number;
    possibleActions?: PossibleActions;
    type?: SelectItem;
    category?: SelectItem;
    subCategory?: SelectItem;
}

export enum ItemState {
    OPEN = 0,
    CLOSED = 1,
    FORCED = 2
}

export interface ItemCategory {
    id: number;
    company: number;
    type: string;
    category: string;
    subCategory: string;
    warehouseMovement: boolean;
    state?: number;  // todo: serve?????????
    possibleActions?: PossibleActions;
}

export enum ItemCategoryAction {
    NEW_ITEM_CATEGORY = 'newItemCategory',
    EDIT_ITEM_CATEGORY = 'editItemCategory',
    TOGGLE_ITEM_CATEGORY = 'toggleItemCategory'
}

export interface ItemCatalogInfo {
    id: number;
    brand: string;
    bigCollection: string;
    collection: string;
    modelColor: string;
    finishingSurface: string;
    thickness: string;
    rectified: boolean;
    outdoor: boolean;
    bigFormat: boolean;
}

export interface ItemSize {
    id: number;
    description: string;
    bigFormat: boolean;
}

export interface ItemLogisticData {
    id: number;
    productId: number;
    minimumStock: number;
    orderQuantity: number;
    packageType: string;
    packageQuantity: number;
    palletQuantity: number;
    weightOfUm: number;
}

export interface ItemImage {
    id: number;
    productId: number;
    imageDescription: string;
    bucketUrl: string;
    thumbnail: boolean;
    ecommerceFlag: boolean;
    state: number;
    possibleActions: PossibleActions;
}

export enum ItemImageAction {
    EDIT_ITEM_IMAGE = "editItemImage",
    TOGGLE_ITEM_IMAGE = "toggleItemImage"
}

export interface ReplaceableItem {
  replaceableProductId: number;
  products: ItemInfo[];
}
